import { Routes } from '@angular/router';

export const COMMISSION_MANAGEMENT_ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'plans',
    pathMatch: 'full'
  },
  {
    path: 'plans',
    children: [
      {
        path: '',
        loadComponent: () => import('./components/commission-plans-list/commission-plans-list.component').then(m => m.CommissionPlansListComponent),
        data: { breadcrumb: 'COMMISSION_PLANS' }
      },
      {
        path: 'create',
        loadComponent: () => import('./components/commission-plans-form/commission-plans-form.component').then(m => m.CommissionPlansFormComponent),
        data: { breadcrumb: 'CREATE_COMMISSION_PLAN' }
      },
      {
        path: 'edit/:id',
        loadComponent: () => import('./components/commission-plans-form/commission-plans-form.component').then(m => m.CommissionPlansFormComponent),
        data: { breadcrumb: 'EDIT_COMMISSION_PLAN' }
      },
      {
        path: ':ownership/:planId/rules',
        data: { breadcrumb: 'COMMISSION_RULES' },
        children: [
          {
            path: '',
            loadComponent: () => import('./components/commission-plan-rules-list/commission-plan-rules-list.component').then(m => m.CommissionPlanRulesListComponent),
            data: { breadcrumb: '' }
          },
          {
            path: 'create',
            loadComponent: () => import('./components/commission-plan-rules-form/commission-plan-rules-form.component').then(m => m.CommissionPlanRulesFormComponent),
            data: { breadcrumb: 'CREATE_COMMISSION_RULE' }
          },
          {
            path: 'edit/:ruleId',
            loadComponent: () => import('./components/commission-plan-rules-form/commission-plan-rules-form.component').then(m => m.CommissionPlanRulesFormComponent),
            data: { breadcrumb: 'EDIT_COMMISSION_RULE' }
          },
          {
            path: ':ruleId/slabs',
            data: { breadcrumb: 'COMMISSION_SLABS' },
            children: [
              {
                path: '',
                loadComponent: () => import('./components/commission-plan-slabs-list/commission-plan-slabs-list.component').then(m => m.CommissionPlanSlabsListComponent),
                data: { breadcrumb: '' }
              },
              {
                path: 'create',
                loadComponent: () => import('./components/commission-plan-slabs-form/commission-plan-slabs-form.component').then(m => m.CommissionPlanSlabsFormComponent),
                data: { breadcrumb: 'CREATE_COMMISSION_SLAB' }
              },
              {
                path: 'edit/:slabId',
                loadComponent: () => import('./components/commission-plan-slabs-form/commission-plan-slabs-form.component').then(m => m.CommissionPlanSlabsFormComponent),
                data: { breadcrumb: 'EDIT_COMMISSION_SLAB' }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: 'staff-assigned',
    loadComponent: () => import('./components/commission-plan-staff-assigned/commission-plan-staff-assigned.component').then(m => m.CommissionPlanStaffAssignedComponent),
    data: { breadcrumb: 'COMMISSION_STAFF_ASSIGNED' }
  },
  {
    path:'commission-transactions',
    loadComponent: () => import('./components/commission-transaction/commission-transaction.component').then(m => m.CommissionTransactionComponent),
    data: { breadcrumb: 'COMMISSION_TRANSACTIONS' }
  }
];

